<template>
  <div class="container">
    <div class="live-box" v-if="lists.length > 1">
      <div class="item" v-for="(item, index) in lists" :key="index" @click="goDetail(item)">
        <div class="vedio">
          <img
            :src="item.collectStatus === 1 ? require('../../../static/collent_yello.png') : require('../../../static/collent.png')"
            @click.stop="toggle(item)"
            class="shoucang"
            alt=""
          />
          <img :src="baseUrl + item.coverPhoto" class="fengmian" alt="" v-if="item.coverPhoto.includes('/hz/hzupload')" />
          <img src="../../../static/占位-直播-列表.png" alt="" v-else />
          <div class="fixed">
            <div class="banner-btn">
           <!------------------------------------------------->
         <!--      <img src="../../../static/HomebackImg.png" alt="" /> -->
           <!------------------------------------------------->
            </div>
          </div>
        </div>
        <div class="title">
          <p>{{ item.liveCn }}{{ screenWidth }}</p>
          <div class="title_icon">
            <img src="../../../static/ico-time.png" alt="" />
            <p style="color: #666; font-size: 16px">
              {{ item.startDate }}
            </p>
          </div>
        </div>
        <div class="down">
          <p>{{ item.exhibitorNameCn }}</p>
        </div>
      </div>
    </div>
    <div v-else class="boxImg">
      <img src="../../../static/empty.png" alt="" />
      <div class="promptInfo">{{ $t('search.nodata') }}</div>
    </div>
    <div class="alert_mess" v-show="visible">
      <img class="close" @click="close" src="../../../static/close.png" />
      <div class="qrcode">
        <img :src="baseUrl + livePhoto" alt="" />
      </div>
      <p>{{ $t('common.qrCode') }}</p>
    </div>
  </div>
</template>

<script>
import { forMat, backLiveDetail } from '../../../../utils/common.js';
import { getLiveLists, collect } from '../../../../api/recommend.js';
export default {
  data() {
    return {
      baseUrl: forMat(),
      lists: [],
      screenWidth: '',
      liveDetailUrl: backLiveDetail(),
      visible: false,
      livePhoto: '',
    };
  },
  created() {
    this.getLists();
  },
  props: ['flag'],
  methods: {
    close() {
      this.visible = false;
    },
    goDetail(item) {
      switch (item.videoType) {
        case '1':
          // 视频 跳详情页
          window.location.href = this.liveDetailUrl + '?userId=' + item.id;
          break;

        case '2':
          // 直播外链 打开新窗口
          window.open(item.videoAddress);
          break;

        case '3':
          //  二维码 弹窗
          this.visible = true;
          this.livePhoto = item.videoAddress;
          break;
      }
    },
    async toggle(item) {
      let status;
      if (item.collectStatus === 0) {
        // 要添加收藏
        status = true;
      } else if (item.collectStatus === 1) {
        status = false;
      }
      const params = {
        objId: item.id,
        flag: status,
        type: 3,
      };
      try {
        const { data } = await collect(params);
        if (data.code === 200) {
          if (item.collectStatus === 0) {
            item.collectStatus = 1;
          } else {
            item.collectStatus = 0;
          }
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getLists() {
      try {
        const { data } = await getLiveLists();
        if (data.code === 200) {
          this.lists = data.data.list;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
  },
  watch: {
    flag(newName, oldName) {
      this.getLists();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 679px;
  width: 100%;
  .live-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .item {
      width: 20%;
      height: 329px;
      border: 1px solid #e0e0e0;
      cursor: pointer;
      margin-bottom: 26px;
      margin-right: 1%;

      .vedio {
        width: 100%;
        height: 162px;
        position: relative;
        .shoucang {
          position: absolute;
          z-index: 9;
          right: 10px;
          top: 10px;
        }
        .fengmian {
          width: 100%;
          height: 100%;
        }
        .fixed {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          background-color: rgba(30, 30, 30, 0.3);
           display: none;


          img {
            // margin: 88px 176px;
            width: 53px;
            height: 65px;
            margin: 49px 118px;
          }
        }
      }
      .vedio:hover > .fixed {
        display: block;
      }

      .title {
        box-sizing: border-box;
        height: 117px;
        padding: 21px 28px 0 24px;
        p {
          padding-bottom: 20px;
          font-size: 18px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          word-break: break-all;
        }
        .title_icon {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          img {
            width: 19px;
            height: 19px;
            margin-right: 2px;
          }
        }
      }
      .down {
        border-top: 1px #e0e0e0 solid;
        height: 52px;
        p {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 52px;
          margin-left: 20px;
          color: #999999;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          word-break: break-all;
        }
      }
    }
  }
  .alert_mess {
    width: 300px;
    height: 320px;
    box-sizing: border-box;
    padding: 5px;
    text-align: center;
    // border: 1px solid black;
    box-shadow: 0px 0px 51px 0px #c1c6cb;
    background: white;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    z-index: 99;

    .close {
      float: right;
      width: 24px;
      height: 24px;
      position: absolute;
      right: 15px;
      top: 15px;
    }
    .qrcode {
      width: 200px;
      height: 200px;
      margin: 26px 40px 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      font-size: 16px;
      font-family: Microsoft YaHei;
      margin-top: 21px;
      font-weight: 400;
      color: #333333;
      line-height: 33px;
    }
  }
}
</style>
<style lang="scss">
.boxImg {
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  img {
    width: 380px;
    height: 300px;
  }
}
</style>
